import { render, staticRenderFns } from "./totalSum.vue?vue&type=template&id=4d994ec3&scoped=true&"
import script from "./totalSum.vue?vue&type=script&lang=js&"
export * from "./totalSum.vue?vue&type=script&lang=js&"
import style0 from "./totalSum.vue?vue&type=style&index=0&id=4d994ec3&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d994ec3",
  null
  
)

export default component.exports